import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import getPersonalizedContent from 'yoda-interfaces/lib/PersonalizedContent/PersonalizedContentApi';
import {
    IRIS_PERSONALIZED_CONTENT_REQUEST,
    IRIS_PERSONALIZED_CONTENT_SUCCESS,
    IRIS_PERSONALIZED_CONTENT_ERROR,
} from '../actionTypes/PersonalizedContentServiceActionTypes';

function* PersonalizedContentServiceSaga(irisPayload) {
    try {
        const irisResponse = yield call(getPersonalizedContent, irisPayload.payload);
        const irisServiceData = get(irisResponse, 'data', {});
        if (irisServiceData.status === 204 || irisServiceData.status === 200) {
            yield put({ type: IRIS_PERSONALIZED_CONTENT_SUCCESS, response: irisServiceData });
        } else {
            const error = {
                errorCode: 'ERROR_WHILE_FETCHING_IRIS_PERSONALIZED_CONTENT',
            };
            yield put({
                type: IRIS_PERSONALIZED_CONTENT_ERROR,
                payload: { response: error, isSuccess: false },
            });
        }
    } catch (error) {
        const err = {
            errorCode: 'ERROR_WHILE_FETCHING_IRIS_PERSONALIZED_CONTENT',
        };
        yield put({
            type: IRIS_PERSONALIZED_CONTENT_ERROR,
            payload: { response: err, isSuccess: false },
        });
    }
}

const watchPersonalizedContentServiceSaga = function* watchPersonalizedContentServiceSaga() {
    yield takeLatest(IRIS_PERSONALIZED_CONTENT_REQUEST, PersonalizedContentServiceSaga);
};

watchPersonalizedContentServiceSaga.sagaName = 'personalizedContentSaga';

export default watchPersonalizedContentServiceSaga;
